import { margins } from '@olist/styled-system';
import styled, { css } from 'styled-components';
import { focusContainer } from '../../utils/focusContainer.js';
import '../../utils/opacityDisabled.js';

const Anchor = styled.a(({ type, theme: { olist: { components }, }, }) => css `
    width: fit-content;
    display: ${type === 'inline' ? 'inline-flex ' : 'flex'};
    align-items: center;
    justify-content: center;
    font-family: ${components.link['font-family']};
    font-weight: ${components.link['font-weight']};
    line-height: ${components.link['line-height']};
    letter-spacing: ${components.link['letter-spacing']};
    text-decoration: ${type === 'inline' ? 'underline' : 'none'};

    color: ${components.link.colors.rest};
    border-radius: ${components.link.radius};

    &:hover,
    &:active,
    &:focus {
      text-decoration: underline;
    }

    &:hover {
      color: ${components.link.colors.hover};
    }

    &:focus {
      color: ${components.link.colors.focus};
    }

    &:active {
      color: ${components.link.colors.active};
    }

    &:visited {
      color: ${components.link.colors.visited};
    }

    svg {
      width: ${components.link.icon.size};
      height: ${components.link.icon.size};
    }

    ${focusContainer() ``}
    ${margins}
  `);
const Label = styled.span(({ size, iconLeft, iconRight, type, theme: { olist: { components }, }, }) => css `
    font-size: ${type === 'inline'
    ? 'inherit'
    : components.link['font-size'][size || 'medium']};
    margin-left: ${iconLeft ? components.link.icon.margin : 0};
    margin-right: ${iconRight ? components.link.icon.margin : 0};
  `);

export { Anchor, Label };
